

//const fetchURL = "http://localhost:8000";
const fetchURL = "https://cdn.song-quiz.de"


export default fetchURL;